module.exports = __webpack_public_path__ + "img/module-profile.edad035e.svg";